import styled from 'styled-components';
export const ButtonContainer = styled.div `
  text-align: -webkit-right;

  .tooltip {
    position: relative;
    display: inline-block;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    background-color: var(--color-neutral-400);
    color: var(--color-contrast-white) !important;
    text-align: center;
    padding: 10px 6px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    width: 150px;
    top: 100%;
    left: 50%;
    margin-left: -60px;
    font-weight: normal !important;
    font-size: var(--font-size-xs);
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  /**
   * O ícone é raster, então precisa de tamanho explícito — o header dimensiona
   * os SVGs por uma regra própria, que não alcança elementos img.
   */
  .chat-icon {
    display: block;
    width: calc(var(--main-menu-size) / 1.5);
    height: calc(var(--main-menu-size) / 1.5);
    object-fit: contain;
  }

  /**
   * Sem o mixin secundaryButton de propósito: ele traz o buttonBase, que
   * pinta o fundo com --color-action-hover no hover e no focus. Atrás de um
   * ícone raster com fundo transparente isso vira um bloco laranja em volta do
   * mascote.
   *
   * O contorno de foco fica: tirar o hover é estética, tirar o foco quebraria
   * a navegação por teclado.
   */
  /*
   * Sem margem lateral de proposito. O botao de download carrega
   * 'margin: 0 var(--main-menu-padding)' porque o container dele tem largura
   * fixa de 66px; aqui o container acompanha o conteudo, e a mesma margem
   * empurrava o icone para fora do alinhamento com o avatar e o gerenciador de
   * relatorios. O espacamento vem do gap do proprio .main-menu_actions.
   */
  button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--main-menu-size);
    height: var(--main-menu-size);
    padding: 0;
    border: none;
    background-color: transparent;

    &:hover {
      background-color: transparent;
    }

    &:focus-visible {
      outline: 2px solid var(--color-contrast-focused);
      outline-offset: 2px;
      border-radius: var(--border-radius-circular);
    }
  }
`;
//# sourceMappingURL=style.js.map